import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import SitesMain from '../../components/sites/SitesMain'
import Footer from '../../components/common/Footer'

export default function SitePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <SitesMain/>
            <Footer/>
        </>
    )
}